import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BeeUnit } from "src/app/domain/core/models/bee-unit";
import { BeeUser } from "src/app/domain/core/models/bee-user";

@Injectable()
export abstract class IUnitService{
  abstract get(id: string): Observable<BeeUnit>;
  abstract getUnitAdministrators(): Observable<BeeUser[]>;
}